import { ImperfectiveVerb } from '../../types'

const пиздеть: ImperfectiveVerb = {
  type: 'imperfective verb',
  infinitive: 'пиздеть',
  imperativePluralSecondPerson: 'пиздите',
  imperativeSingularSecondPerson: 'пизди',
  indicativePastPlural: 'пиздели',
  indicativePastSingularFeminine: 'пиздела',
  indicativePastSingularMasculine: 'пиздел',
  indicativePastSingularNeuter: 'пиздело',
  indicativePresentPluralFirstPerson: 'пиздим',
  indicativePresentPluralSecondPerson: 'пиздите',
  indicativePresentPluralThirdPerson: 'пиздят',
  indicativePresentSingularFirstPerson: 'пизжу',
  indicativePresentSingularSecondPerson: 'пиздишь',
  indicativePresentSingularThirdPerson: 'пиздит',
}

export default пиздеть
